import { Field } from "formik";
import Select from "react-select";
import { formatUnderscoreToSpace } from "../../utils/text-format";

export const FormDropDown = ({
  name = "select",
  label = "select field",
  options = [],
  required,
  placeholder,
  // Show a clear (x) button so a value picked by mistake can be reset to none
  isClearable = true,
  // Remove 'value' from props here, we'll get it from field.value
  ...props
}) => {
  return (
    <Field name={name}>
      {({ field, form, meta }) => {
        // Find the option that matches the CURRENT Formik value
        const currentValue =
          options.find((option) => option.value === field.value) || null;

        return (
          <div>
            <label
              className={`text-fs_16 capitalize ${
                meta.touched && meta.error ? "text-errorColor" : "text-darkText"
              }`}
            >
              {formatUnderscoreToSpace(label)}
            </label>
            <div
              className={`border-[1px] rounded-lg px-[0.2rem] py-[0.1rem] pb-[0.4rem] mt-1 my-4 w-full ${
                meta.touched && meta.error
                  ? "border-errorColor"
                  : "border-greyText"
              }`}
            >
              <Select
                {...field}
                name={name}
                value={currentValue}
                options={options}
                placeholder={placeholder}
                isClearable={isClearable}
                onChange={(selectedOption) =>
                  form.setFieldValue(name, selectedOption?.value ?? null)
                }
                onBlur={() => form.setFieldTouched(name, true)}
                styles={customStyles}
              />
            </div>
            {/* Error labels */}
          </div>
        );
      }}
    </Field>
  );
};

export const FormMultiSelectDropDown = ({
  name = "select",
  label = "select field",
  options = [],
  required,
  placeholder,
  value,
  ...props
}) => {
  return (
    <Field name={name}>
      {({ field, form, meta }) => (
        <div>
          <label
            className={`text-fs_16 capitalize ${
              meta.touched && meta.error ? "text-errorColor" : "text-darkText"
            }`}
          >
            {formatUnderscoreToSpace(label)}
          </label>
          <div
            className={`border-[1px] rounded-lg px-[0.2rem] py-[0.1rem] pb-[0.4rem] mt-1 w-full ${
              meta.touched && meta.error
                ? "border-errorColor"
                : "border-greyText"
            }`}
          >
            <Select
              {...field}
              name={name}
              isMulti
              value={value}
              options={options}
              placeholder={placeholder}
              onChange={(selectedOptions) =>
                form.setFieldValue(
                  name,
                  selectedOptions.map((option) => option.value),
                )
              }
              onBlur={() => form.setFieldTouched(name, true)}
              styles={customStyles}
              required={required}
            />
          </div>
          <label className="text-errorColor text-fs_14 ps-1 mt-1 h-[1rem] flex items-center">
            {meta.touched && meta.error && meta.error}
          </label>
        </div>
      )}
    </Field>
  );
};

export const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    color: "#0000",
    width: "100%",
    border: "none",
    boxShadow: state.isFocused ? null : null,
  }),
  placeholder: (defaultStyles) => ({
    ...defaultStyles,
    color: "#B0B3C7",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    color: "#50BF97",
    ":hover": {
      backgroundColor: "#50BF97",
      color: "white",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected ? "white" : "black",
    backgroundColor: state.isSelected ? "#50BF97" : "white",
    ":hover": {
      backgroundColor: "#50BF97",
      color: "white",
    },
  }),
};
